export default __webpack_public_path__ + "static/media/menu.9f1bc1ce.svg";